'use client'
import { useState, Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { useRouter } from 'next/navigation'
import ButtonAction from './ButtonAction'
import { sendLogin, recoverPasswordReq } from 'services/access'

const Modal = ({
  showModal,
  setShowModal,
  setFedId,
  setFedToken,
  setClubId,
  setClubToken,
  setIsLogged
}) => {
  const [formData, setFormData] = useState({})
  const [msgRecover, setMsgRecover] = useState()
  const [error, setError] = useState()
  const [errorRecover, setErrorRecover] = useState()
  const [recoverPassword, setRecoverPassword] = useState(false)
  const [passwordType, setPasswordType] = useState('password')
  const [loginTo, setLoginTo] = useState('person')
  const router = useRouter()

  const handleLogin = async (event) => {
    setError('')
    event.preventDefault()
    const res = await sendLogin({
      data: formData,
      club: loginTo !== 'person'
    })
    if (res.Data?.token) {
      if (loginTo === 'person') {
        setFedId(formData.user)
        setFedToken(res.Data.token)
        localStorage.removeItem('clubId')
        localStorage.removeItem('clubToken')
        localStorage.setItem('fedId', formData.user)
        localStorage.setItem('fedToken', res.Data.token)
        router.push('/privat/federat/dades-personals')
      } else {
        setClubId(formData.user)
        setClubToken(res.Data.token)
        localStorage.removeItem('fedId')
        localStorage.removeItem('fedToken')
        localStorage.setItem('clubId', formData.user)
        localStorage.setItem('clubToken', res.Data.token)
        router.push('/privat/club/dades/principal')
      }
      setIsLogged(true)
      setShowModal(false)
    } else if (res.resultado === 'ERROR') {
      setError(res.error_desc)
    }
  }

  const handleRecover = async (event) => {
    event.preventDefault()
    setErrorRecover('')
    const res = await recoverPasswordReq({ ...formData })
    if (res.Data?.Email === 'SEND') {
      setMsgRecover("T'hem enviat la teva contrasenya al teu email")
    } else if (res.resultado === 'ERROR') {
      setErrorRecover(res.error_desc)
    }
  }

  const handleChange = (event) => {
    const { name, value } = event.target
    const updateData = { ...formData }
    updateData[name] = value
    setFormData(updateData)
  }

  return (
    <Transition.Root show={showModal} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={setShowModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-md bg-sec-grey-3 px-6 lg:px-16 text-left shadow-xl transition-all sm:my-8">
                <div className="flex">
                  <button
                    className="flex-1 whitespace-nowrap"
                    onClick={() => {
                      setLoginTo('person')
                    }}
                  >
                    <h2
                      className={`text-3xl lg:text-4xl font-light py-10 ${
                        loginTo === 'person'
                          ? 'text-blue '
                          : 'text-sec-grey-30 hover:text-blue'
                      }`}
                    >
                      Àrea Privada
                    </h2>
                  </button>
                  <div className="border-sec-grey-1 border mx-5 lg:mx-10"></div>
                  <button
                    className="flex-1 whitespace-nowrap"
                    onClick={() => {
                      setLoginTo('club')
                    }}
                  >
                    <h2
                      className={`text-3xl lg:text-4xl font-light py-10 ${
                        loginTo === 'club'
                          ? 'text-blue '
                          : 'text-sec-grey-30 hover:text-blue'
                      }`}
                    >
                      Àrea Club
                    </h2>
                  </button>
                </div>
                {recoverPassword ? (
                  <>
                    {msgRecover ? (
                      <p className="text-blue font-alliance-light text-[14px] lg:text-[22px] mt-4">
                        {msgRecover}
                      </p>
                    ) : (
                      <form
                        className="lg:grid lg:grid-cols-1 lg:gap-x-12 xl:gap-x-32"
                        onSubmit={handleRecover}
                      >
                        <label className="block text-md text-blue mt-8">
                          Completi les següents dades per validar la seva
                          identitat
                        </label>
                        <div className="grid grid-cols-1 lg:grid-cols-2">
                          <div className="my-2 lg:my-6 mr-6">
                            <label
                              htmlFor="id"
                              className="block text-md text-blue"
                            >
                              Nº llicència
                            </label>
                            <div className="mt-2">
                              <input
                                type="text"
                                id="id"
                                name="id"
                                className="bg-sec-grey-4 block w-full rounded-md border-sec-grey-4 shadow-sm py-3 border-none focus:ring-0"
                                onChange={handleChange}
                                required={true}
                              />
                            </div>
                          </div>
                          <div className="my-6">
                            <label
                              htmlFor="birthDate"
                              className="block text-md font-md text-blue"
                            >
                              Data de Naixement
                            </label>
                            <div className="mt-2">
                              <input
                                type="date"
                                id="birthDate"
                                name="birthDate"
                                className="bg-sec-grey-4 block w-full rounded-md border-sec-grey-4 shadow-sm py-3 border-none focus:ring-0"
                                onChange={handleChange}
                                required={true}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="grid grid-cols-1 lg:grid-cols-2">
                          <div className="my-2 lg:my-6 mr-6">
                            <label
                              htmlFor="document"
                              className="block text-md text-blue"
                            >
                              DNI / CatSalut
                            </label>
                            <div className="mt-2">
                              <input
                                type="text"
                                id="document"
                                name="document"
                                className="bg-sec-grey-4 block w-full rounded-md border-sec-grey-4 shadow-sm py-3 border-none focus:ring-0"
                                onChange={handleChange}
                                required={true}
                              />
                            </div>
                          </div>
                          <div className="my-6">
                            <label
                              htmlFor="email"
                              className="block text-md font-md text-blue"
                            >
                              Email
                            </label>
                            <div className="mt-2">
                              <input
                                type="email"
                                id="email"
                                name="email"
                                className="bg-sec-grey-4 block w-full rounded-md border-sec-grey-4 shadow-sm py-3 border-none focus:ring-0"
                                onChange={handleChange}
                                required={true}
                              />
                            </div>
                          </div>
                        </div>
                        <ButtonAction
                          text="Recuperar"
                          type="submit"
                          className="mt-4"
                        />
                        {errorRecover && (
                          <p className="text-sec-red font-alliance-light text-[14px] lg:text-[22px] mt-4">
                            {errorRecover}
                          </p>
                        )}
                      </form>
                    )}
                    <button
                      onClick={() => {
                        setFormData({})
                        setRecoverPassword(false)
                      }}
                      className="w-full flex justify-center ml-2"
                    >
                      <p className="mt-6 text-blue text-center mb-14 underline">
                        Logueate aquí
                      </p>
                    </button>
                  </>
                ) : (
                  <form
                    className="lg:grid lg:grid-cols-1 lg:gap-x-12 xl:gap-x-32"
                    onSubmit={handleLogin}
                  >
                    <div className="mb-8">
                      <label htmlFor="user" className="block text-md text-blue">
                        Usuari
                      </label>
                      <div className="mt-2">
                        <input
                          type="text"
                          id="user"
                          name="user"
                          className="bg-sec-grey-4 block w-full rounded-md border-sec-grey-4 shadow-sm py-3 border-none focus:ring-0"
                          onChange={handleChange}
                          required={true}
                        />
                      </div>
                    </div>
                    <div className="mb-6">
                      <label
                        htmlFor="pass"
                        className="block text-md font-md text-blue"
                      >
                        Contrasenya
                      </label>
                      <div className="relative mt-2 flex">
                        <input
                          type={passwordType}
                          id="pass"
                          name="pass"
                          className="bg-sec-grey-4 block w-full rounded-md border-sec-grey-4 shadow-sm py-3 border-none focus:ring-0"
                          onChange={handleChange}
                          required={true}
                        />
                        <a
                          className="absolute flex right-0 top-0 bottom-0 mr-5 hover:cursor-pointer"
                          onClick={() => {
                            setPasswordType((type) =>
                              type === 'password' ? 'text' : 'password'
                            )
                          }}
                        >
                          <img
                            src={`/assets/icons/eye${
                              passwordType === 'text' ? '-closed' : ''
                            }.svg`}
                            alt="icon"
                            className="w-6"
                          />
                        </a>
                      </div>
                    </div>
                    <div className="flex items-center mb-8">
                      <div className="flex items-center">
                        <input
                          id="remember"
                          name="remember"
                          type="checkbox"
                          className="h-4 w-4 border-blue text-blue focus:ring-blue"
                          defaultChecked="false"
                        />
                        <label
                          htmlFor="remember"
                          className="ml-3 block text-md text-blue"
                        >
                          Recorda’m
                        </label>
                      </div>
                      <button
                        className="underline ml-auto text-blue"
                        onClick={() => {
                          setFormData({})
                          setRecoverPassword(true)
                        }}
                      >
                        Has oblidat la contrasenya?
                      </button>
                    </div>
                    <ButtonAction text="Accedir" type="submit" />
                    <p className="text-sec-red font-alliance-light text-[14px] lg:text-[22px] mt-4">
                      {error}
                    </p>
                    <p className="mt-6 text-blue text-center mb-14">
                      No estàs federat?
                      <a
                        href="/llicencies/solicitud-llicencia"
                        className="underline ml-2"
                      >
                        Fes-ho aquí!
                      </a>
                    </p>
                  </form>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

export default Modal
